import z from 'zod'

import { EmailZ, GenderZ, RelativeURLZ, UserCurrencyZ, UserIdZ } from './common'
import { LocalesZ } from './locale'

export const PersonNamesZ = z.object({
	first_name: z.string(),
	middle_name: z.string().nullable(),
	last_name: z.string(),
})
export type PersonNames = z.infer<typeof PersonNamesZ>

// eslint-disable-next-line no-restricted-syntax
export enum UserStatus {
	Created = 'CREATED',
	Invited = 'INVITED',
	Registered = 'REGISTERED',
	Deactivated = 'DEACTIVATED',
}
export const UserStatusZ = z.enum(UserStatus)

export const ObFeeMockValuez = z.enum([
	'success_with_ob_fee',
	'failure_with_ob_fee',
	'success_with_ob_fee_embedded',
	'ob_fee_price_change',
])
export const ObFeeMockValue = ObFeeMockValuez.enum
export type ObFeeMockValue = z.infer<typeof ObFeeMockValuez>

// TODO: not all properties have schema created
export const UserNewZ = z.object({
	auto_select_self: z.boolean(),
	bookable: z.boolean().optional(),
	currency_code: UserCurrencyZ,
	deactivate_at: z.date().or(z.string()).nullable(),
	deleted: z.boolean(),
	email: EmailZ,
	gender: GenderZ.nullish(),
	id: UserIdZ,
	image_url: RelativeURLZ.nullish(),
	invoice_profile: z.any().nullable(), // (InvoiceProfile | null)?
	is_admin: z.boolean().optional(),
	language_code: LocalesZ.nullable(),
	status: UserStatusZ,
	mock_enabled: z.boolean().optional(),
	tokenizer_mock_enabled: z.boolean().optional(),
	worldline_mock_enabled: z.boolean().optional(),
	flight_search_mock_enabled: z.boolean().optional(),
	ob_fee_mock: ObFeeMockValuez.nullish(),
	traveler_profile: z.any().nullish(), // TravelProfile?
	user_permissions: z.array(z.any()).optional(), // UserPermission[]?
	user_roles: z.array(z.any()).optional(), // UserRole[]?
	...PersonNamesZ.shape,
})
export type UserNew = z.infer<typeof UserNewZ>
